import React from "react";
import "./LandingPublicHotelBookingMock.scss";

function SvgSearch(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" aria-hidden {...props}>
      <circle cx="11" cy="11" r="7" />
      <path d="M20 20l-4.2-4.2" strokeLinecap="round" />
    </svg>
  );
}

function SvgHeart(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden {...props}>
      <path d="M12 21s-8-4.5-8-10.5A5.5 5.5 0 0112 5a5.5 5.5 0 0110 5.5C22 16.5 12 21 12 21z" />
    </svg>
  );
}

/**
 * תצוגת דמו מיניאטורית — מדמה אתר ציבורי חיפוש מלונות (RTL) לקטגוריית «תראו את המערכת מבפנים».
 */
export function LandingPublicHotelBookingMock() {
  return (
    <div className="hr-pubhotel" aria-hidden>
      <nav className="hr-pubhotel__rail">
        <span className="hr-pubhotel__railIc hr-pubhotel__railIc--hot" />
        {[1, 2, 3, 4, 5].map((n) => (
          <span key={n} className="hr-pubhotel__railIc" />
        ))}
      </nav>

      <div className="hr-pubhotel__main">
        <header className="hr-pubhotel__top">
          <div className="hr-pubhotel__logo" translate="no">
            R&nbsp;<span>MORE</span>
          </div>
          <div className="hr-pubhotel__tools">
            <span className="hr-pubhotel__pill">₪ ILS</span>
            <span className="hr-pubhotel__pill">עב</span>
            <span className="hr-pubhotel__avatar" />
          </div>
        </header>

        <div className="hr-pubhotel__kpi-row" aria-hidden>
          <span className="hr-pubhotel__kpi hr-pubhotel__kpi--p">מבצעים</span>
          <span className="hr-pubhotel__kpi hr-pubhotel__kpi--b">דירוג גבוה</span>
          <span className="hr-pubhotel__kpi hr-pubhotel__kpi--g">זמין עכשיו</span>
        </div>

        <div className="hr-pubhotel__search-sheet">
          <div className="hr-pubhotel__fld">
            <span className="hr-pubhotel__fldLbl">יעד / שם מלון</span>
            <span className="hr-pubhotel__fldPh">דובאי, איחוד האמירויות</span>
          </div>
          <div className="hr-pubhotel__fld">
            <span className="hr-pubhotel__fldLbl">תאריכים</span>
            <span className="hr-pubhotel__fldPh">16.08&nbsp;→&nbsp;20.08</span>
          </div>
          <div className="hr-pubhotel__fld">
            <span className="hr-pubhotel__fldLbl">אורחים</span>
            <span className="hr-pubhotel__fldPh">2 מבוגרים · חדר 1</span>
          </div>
          <button type="button" className="hr-pubhotel__go" tabIndex={-1}>
            <SvgSearch />
          </button>
        </div>

        <div className="hr-pubhotel__filters">
          <button type="button">מחיר</button>
          <button type="button">כוכבים</button>
          <button type="button">מתקנים</button>
          <button type="button">מיקום</button>
        </div>

        <div className="hr-pubhotel__stage">
          <div className="hr-pubhotel__grid">
            <article className="hr-pubhotel__card">
              <div className="hr-pubhotel__cardHero" />
              <div className="hr-pubhotel__cardBody">
                <div className="hr-pubhotel__stars">★★★★★</div>
                <h4 className="hr-pubhotel__hname" translate="no">
                  Ramada by Wyndham Downtown
                </h4>
                <p className="hr-pubhotel__loc">מרכז עיר · דובאי</p>
                <div className="hr-pubhotel__priceRow">
                  <strong>₪ ‎1 248</strong>
                  <span className="hr-pubhotel__mag">
                    <SvgSearch />
                  </span>
                </div>
              </div>
              <footer className="hr-pubhotel__cardFoot">
                <button type="button" className="hr-pubhotel__iconBtn" tabIndex={-1}>
                  <SvgHeart />
                </button>
                <button type="button" className="hr-pubhotel__primary" tabIndex={-1}>
                  צפייה בחדרים
                </button>
              </footer>
            </article>

            <article className="hr-pubhotel__card">
              <div className="hr-pubhotel__cardHero hr-pubhotel__cardHero--2" />
              <div className="hr-pubhotel__cardBody">
                <div className="hr-pubhotel__stars">★★★★☆</div>
                <h4 className="hr-pubhotel__hname">מלון בוטיק ג׳ומיירה</h4>
                <p className="hr-pubhotel__loc">ג׳ומיירה · דובאי</p>
                <div className="hr-pubhotel__priceRow">
                  <strong>₪ ‎892</strong>
                  <span className="hr-pubhotel__mag">
                    <SvgSearch />
                  </span>
                </div>
              </div>
              <footer className="hr-pubhotel__cardFoot">
                <button type="button" className="hr-pubhotel__iconBtn" tabIndex={-1}>
                  <SvgHeart />
                </button>
                <button type="button" className="hr-pubhotel__primary" tabIndex={-1}>
                  צפייה בחדרים
                </button>
              </footer>
            </article>
          </div>

          <aside className="hr-pubhotel__modal">
            <div className="hr-pubhotel__modalHero">
              <div className="hr-pubhotel__modalPriceTag">
                <span>₪ ‎456</span>
                <button type="button" tabIndex={-1}>
                  הזמנת חדרים
                </button>
              </div>
              <h3 className="hr-pubhotel__modalTitle" translate="no">
                Mercure Gold Hotel Jumeirah Dubai by Accor
              </h3>
            </div>
            <div className="hr-pubhotel__thumbs">
              {[0, 1, 2, 3].map((i) => (
                <span key={i} />
              ))}
            </div>
            <div className="hr-pubhotel__summary">
              <h4>סיכום שהייה</h4>
              <table className="hr-pubhotel__sumTbl">
                <tbody>
                  <tr>
                    <th scope="row">תאריכים</th>
                    <td>
                      ‎16.08.2025<span dir="ltr"> — </span>20.08.2025
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">לילות</th>
                    <td>‎4</td>
                  </tr>
                  <tr>
                    <th scope="row">חדרים</th>
                    <td>‎1</td>
                  </tr>
                  <tr>
                    <th scope="row">אורחים</th>
                    <td>מבוגר ‎2</td>
                  </tr>
                </tbody>
              </table>
              <p className="hr-pubhotel__sumNote">ניתן לעדכן פרטים בשלב בחירת החדרים.</p>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
}
